/** Mirror of constants/serviceRequestTaxonomy.js (keep in sync). */

export const SERVICE_CATEGORIES = {
  menu_price: { domain: 'store_content', label: '가격 · 사이즈', legacyTypes: ['price_change', 'size_change'] },
  menu_catalog: { domain: 'store_content', label: '메뉴 추가 · 삭제 · 수정', legacyTypes: ['new_menu', 'remove_menu', 'menu_update'] },
  seasonal: { domain: 'store_content', label: '시즈널 메뉴 · SKU', legacyTypes: ['seasonal_participation'] },
  media: { domain: 'store_content', label: '동영상 · 이미지', legacyTypes: ['content_change', 'video_change', 'image_change'] },
};

export const CATEGORY_ORDER = ['menu_price', 'menu_catalog', 'seasonal', 'media'];
